<template>
  <div class="animated fadeIn">
    <SubHeaderDash></SubHeaderDash>
    <DashCards :dashItems="dashboardCards"></DashCards>
    <EventDetailModal></EventDetailModal>
    <ManageEmailModal></ManageEmailModal>
    <EmailHistoriesManagement></EmailHistoriesManagement>
  </div>
</template>

<script>
  import dashboard from '../../_dash';
  import SubHeaderDash from '../../components/subHeaders/SubHeaderDash';
  import DashCards from '../../components/DashCards';
  import EventDetailModal from '../../components/modal/event/EventDetailModal';
  import ManageEmailModal from '../../views/email/ManageEmail';
  import {mapActions} from 'vuex';
  import EmailHistoriesManagement from '../../views/email/EmailHistoriesManagement';

  export default {
    name: 'home',
    components: {
      SubHeaderDash,
      DashCards,
      EventDetailModal,
      ManageEmailModal,
      EmailHistoriesManagement
    },
    data () {
      return {
        dashboardCards: dashboard.items
      };
    },
    methods: {
      ...mapActions({
        getEventCount: 'ACTION_GET_EVENT_COUNT'
      })
    },
    beforeMount () {
      this.getEventCount();
    }
  }
</script>


<style>

</style>



// WEBPACK FOOTER //
// Dashboard.vue?53a1c74a